import { httpsCallable } from 'firebase/functions'
import { firebaseFunctions } from './firebase'
import type { DisplayPreferenceType } from '../types/schema'

export type UpdateUserProfileInput = {
  firstName: string
  lastName: string
  username: string
  phone: string
  address?: string
  educationNotes?: string
  displayType: DisplayPreferenceType
}

export type UpdateUserProfileImageInput =
  | { source: 'GOOGLE' }
  | { source: 'AVATAR'; avatarId: string }

const updateUserProfileCallable = httpsCallable<UpdateUserProfileInput, { ok: true; username: string }>(
  firebaseFunctions,
  'updateUserProfile',
)

const updateUserProfileImageCallable = httpsCallable<UpdateUserProfileImageInput, { ok: true; photoURL: string }>(
  firebaseFunctions,
  'updateUserProfileImage',
)

export const updateUserProfile = async (input: UpdateUserProfileInput) => {
  const result = await updateUserProfileCallable(input)
  return result.data
}

export const updateUserProfileImage = async (input: UpdateUserProfileImageInput) => {
  const result = await updateUserProfileImageCallable(input)
  return result.data
}
